var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMagicSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 4.22002V19.77H2.25V11.6075H4.13033V17.895H19.875V6.09984H9.6125V4.22002H21.75ZM12 8.14502L10.7969 10.7919L8.15 11.995L10.7969 13.1981L12 15.845L13.2031 13.1981L15.85 11.995L13.2031 10.7919L12 8.14502Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 2.995L5.43572 5.30927L7.75 6.37L5.4375 7.42L4.375 9.745L3.3125 7.42L1 6.37L3.31427 5.30927L4.375 2.995Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagicSelection);
export default __webpack_public_path__ + "static/media/icon-magic-selection.0a2acec983a0a12e2948fcf6ab147e3e.svg";
export { ForwardRef as ReactComponent };